const IMAGE_URL_PREFIX_MAP = [
  {
    from: 'http://images.radionetportal.com',
    to: 'https://rnmasuploads.blob.core.windows.net'
  },
  {
    from: 'https://images.radionetportal.com',
    to: 'https://rnmasuploads.blob.core.windows.net'
  }
]

export const imageUrlReplace = (url?: string) => {
  if (!url) return url

  const match = IMAGE_URL_PREFIX_MAP.find((item) => url.startsWith(item.from))

  if (match) {
    return url.replace(match.from, match.to)
  }

  return url
}
